const localization = {
  en: {
    myHealth: 'My Health'
  },
  es: {
    myHealth: 'Mi Salud'
  },
  keyMapping: {
    myHealth: 'UFD_My_Health_Button'
  }
}

export default localization

